

function fnServicesAccordion() {
    document.addEventListener('DOMContentLoaded', function() {
        if (document.querySelector('.page-template-template_landing')) {

            let accordions = [...document.querySelectorAll('.acc_list')];
            let buttons = [...document.querySelectorAll('.accordion-btn')];
            
            accordions.forEach((acc, idx) => {
                acc.addEventListener('click', () => {
                    let panel = acc.nextElementSibling;

                    if (panel.classList.contains('active')) {
                        buttons[idx].classList.remove('activeBtn');
                        panel.classList.remove('active');
                        console.log('HAS ACTIVE CLASS');

                    }
                    
                    accordions.forEach((item, i) => {
                        item.nextElementSibling.classList.remove('active');
                        buttons[i].classList.remove('activeBtn');
                    });

                    panel.classList.add('active');
                    buttons[idx].classList.add('activeBtn');
                });
            });
        }
    });
}